{
  "area": {
    "driving": "Driving",
    "woods_and_hybrids": "Woods and hybrids",
    "long_irons": "Long irons",
    "mid_irons": "Mid irons",
    "short_irons": "Short irons",
    "wedges": "Wedges",
    "short_game": "Short game",
    "bunkers": "Bunkers",
    "putting": "Putting",
    "course_management": "Course management",
    "mental": "Mental",
    "physical_and_conditions": "Physical and conditions"
  },
  "skill": {
    "drv_dist": "Driving distance",
    "drv_acc": "Driving accuracy",
    "woods": "Woods and hybrids",
    "long_irons": "Long irons",
    "mid_irons": "Mid irons",
    "short_irons": "Short irons",
    "wedges": "Wedges",
    "pitching": "Pitching",
    "chipping": "Chipping",
    "bunkers": "Bunkers",
    "putt_short": "Short putts",
    "putt_medium": "Mid-range putts",
    "putt_long": "Long putts",
    "course_mgmt": "Course management",
    "composure": "Composure",
    "consistency": "Consistency",
    "fitness": "Fitness",
    "weather": "Bad-weather play",
    "recovery": "Recovery"
  },
  "lead": {
    "driving": "drives it like",
    "drv_dist": "drives it as far as",
    "drv_acc": "drives it as straight as",
    "woods": "hits woods and hybrids like",
    "long_irons": "hits long irons like",
    "mid_irons": "hits mid irons like",
    "short_irons": "hits short irons like",
    "wedges": "hits wedges like",
    "short_game": "chips and pitches like",
    "pitching": "pitches like",
    "chipping": "chips like",
    "bunkers": "plays from sand like",
    "putting": "putts like",
    "putt_short": "holes short putts like",
    "putt_medium": "putts from mid-range like",
    "putt_long": "lags long putts like",
    "course_mgmt": "plots a way round like",
    "mental": "holds a round together like",
    "composure": "handles pressure like",
    "consistency": "repeats the swing like",
    "physical_and_conditions": "copes with trouble and bad weather like",
    "weather": "plays in bad weather like",
    "recovery": "gets out of trouble like"
  },
  "comparison": {
    "best": "one of the best in the world",
    "tour": "a tour professional",
    "beginner": "a complete beginner",
    "plus": "a +{figure} handicapper",
    "scratch": "a scratch golfer",
    "handicap": "{figure, select, 8 {an 8 handicapper} 11 {an 11 handicapper} 18 {an 18 handicapper} other {a {figure} handicapper}}"
  },
  "fitness": {
    "fitness_above": "fitter than most golfers of this age",
    "fitness_about": "about as fit as most golfers of this age",
    "fitness_build": "has fitness to build"
  },
  "label": "{lead} {comparison}",
  "row": "{name} {number}, {label}",
  "playing_level": "Playing level {level}",
  "playing_level_rust": "Playing level {level}, includes {rust} rust"
}
